module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Square</h1>\n</div>\n<iframe src=\"apps/square/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/square/square.component.html
// module id = ../../../../../src/app/pages/square/square.component.html
// module chunks = main